import AboutStyles from "../About.module.css";
import Brandis from "../../../assets/images/headshots/Brandis.svg";
import Damien from "../../../assets/images/headshots/Damien.jpg";
import Christy from "../../../assets/images/headshots/Crystal.png";
import Faith from "../../../assets/images/headshots/Faith-1.png";
import Salina from "../../../assets/images/headshots/Salina.png";

const dash = <span style={{ fontFamily: "Arial" }}>-</span>;
const parentLeft = <span style={{ fontFamily: "Arial" }}>(</span>;
const parentRight = <span style={{ fontFamily: "Arial" }}>)</span>;
const slash = <span style={{ fontFamily: "Arial" }}>/</span>;
const comma = <span style={{ fontFamily: "Arial" }}>'</span>;
const num = <span style={{ fontFamily: "Arial" }}>4</span>;
const and = <span style={{ fontFamily: "Arial" }}>&</span>;

const HeadshotData = [
  {
    id: 1,
    title: "CEO & PRESIDENT",
    subTitle: "ACBC Founder: Brandis Boyd-Cooper, CMA/CDT",
    img: Brandis,
    alt: "ACBC Founder Brandis Boyd-Cooper, CMA/CDT",
    body: (
      <>
        Brandis is a Biologic Access Coordinator with over twenty years of
        experience. Her specialty focuses have included Immunodermatology with
        crossover training in rheumatology. Her diverse experience, knowledge,
        and profound passion have enabled her to teach others a proficient
        workflow for processing multiple variations of specialty medications
        including orals, injectables, topicals, and outpatient infusion
        coordination.
      </>
    ),
    bodyExt: (
      <>
        Brandis is a renowned industry speaker and KOL. She has worked with
        multiple profound physicians and mid{dash}level providers including
        Melissa Costner, M.D., Jennifer Cather. M.D., Melodie Young, N.P.,
        Daniel Walker, M.D. and Dario Kivelevitch, M.D. She is the founder and
        CEO of BioMazze Coordination, President and Co{dash}Founder of Access
        Coordinator Boot Camp, and the Regional Biologic Coordinator for US
        Dermatology Partners in the DFW area.
      </>
    ),
  },
  {
    id: 2,
    title: "ACBC Director",
    subTitle: "Crystal Thompson CPhT, PACS",
    img: Christy,
    alt: "Crystal Thompson CPhT, PACS",
    body: (
      <>
        Crystal is a highly experienced Biologic Access and Prior Authorization
        Coordinator with over 20 years in healthcare. She is a Certified
        Pharmacy Technician {parentLeft}CPhT{parentRight} and is PACS certified,
        adding additional expertise to her broad skill set. Crystal{comma}s
        knowledge spans multiple specialties, including gastroenterology,
        infusion therapy, rheumatology, immunology, and revenue cycle
        management, among others.
      </>
    ),
    bodyExt: (
      <>
        Her extensive experience, dedication, and passion for her work have
        positioned her as a valuable resource to healthcare professionals in the
        South Carolina area, as well as those she reaches through the Access
        Coordinator Boot Camp {parentLeft}ACBC{parentRight}. Throughout her
        career, Crystal has collaborated with distinguished physicians and mid
        {dash}level providers, including Dr. James A. Richter. She is deeply
        committed to ensuring that patients have access to the medications they
        need while also educating providers and healthcare teams on the ever
        {dash}evolving landscape of medication regulations.
      </>
    ),
  },
  {
    id: 3,
    title: "ACBC Director",
    subTitle: "Faith Trujillo",
    img: Faith,
    alt: "Faith Trujillo",
    body: (
      <>
        With five years of specialized experience in biologics coordination,
        Faith is committed to advancing educational initiatives for biologics
        and access coordinators across the nation through her role at ACBC.
        Currently serving as a Clinical Research and Biologics Coordinator and
        Las Vegas Dermatology in LV, NV, Faith works under the expert guidance
        of Dr. David Cotter and Dr. Harry Greenberg.
      </>
    ),
    bodyExt: (
      <>
        Her role involves managing complex biologic treatments and research
        protocols, providing her with a deep understanding of the challenges and
        opportunities in the field. Faiths leadership at ACBC is marked by her
        commitment to professional development, her passion for enhancing the
        skills of access coordinators, and her drive to foster collaboration and
        innovation within the industry. Her efforts aim to elevate the standards
        of care and support for patients navigating biologic therapies.
      </>
    ),
  },
  {
    id: 4,
    title: "ACBC Director",
    subTitle: "Salina Morales NRCCS",
    img: Salina,
    alt: "Salina Morales NRCCS",
    body: (
      <>
        Salina Morales, NRCCS, is an Implementation Manager at MedicoCX, where
        she oversees biologics programs across multiple healthcare practices in
        various specialties. With 9 years of experience in the healthcare
        industry, she brings a deep understanding of billing processes and has
        specialized as a Biologics Coordinator for the past four years. Salina
        is dedicated to optimizing patient care and ensuring the efficient
        management of biologics services in each practice she supports.
      </>
    ),
    bodyExt: (
      <>
        In addition to her role at MedicoCX, Salina serves as the Secretary for
        the Access Coordinator Boot Camp, where she demonstrates her leadership
        and commitment to education in healthcare. Her extensive background in
        billing and biologics coordination allows her to make meaningful
        contributions to the industry while mentoring others in the field.
      </>
    ),
  },
  {
    id: 5,
    title: "ACBC Pharmacy Service Director",
    subTitle: "Damien Fisher PharmD., AE-C",
    img: Damien,
    alt: "Damien Fisher",
    body: (
      <>
        Damien Fisher graduated from Florida A{and}M University College of
        Pharmacy with a Dr. of Pharmacy degree in 200{num}. He prolonged his
        studies and completed an ASHP Accredited Residency with an Emphasis on
        Community and Ambulatory Care at the University of Tennessee. He became
        intrigued in academia, during his career he has held three Clinical
        Assistant Professor positions at the Hampton University School of
        Pharmacy and the University of Houston College of Pharmacy, as well as
        South University School of Pharmacy.
      </>
    ),
    bodyExt: (
      <>
        He currently serves as an adjunct professor at Texas Southern University
        College of Pharmacy {and} works for the University Texas Medical
        Branch&nbsp;
        {parentLeft}UTMB{parentRight} Health League City team as an outpatient
        Allergy{slash}Dermatology{slash}Pulmonology Clinical Pharmacy
        Specialist.
      </>
    ),
  },

  // FOR DESKTOP
  {
    id: 6,
    title: "CEO & PRESIDENT",
    subTitle: "ACBC Founder: Brandis Boyd-Cooper, CMA/CDT",
    img: Brandis,
    alt: "Brandis Boyd-Cooper, CMA/CDT",
    body: (
      <>
        Brandis is a Biologic Access Coordinator with over twenty years of
        experience. Her specialty focuses have included Immunodermatology with
        crossover training in rheumatology. Her diverse experience, knowledge,
        and profound passion have enabled her to teach others a proficient
        workflow. With Brandis you learn how to process multiple variations of
        specialty medications including orals, injectables, topicals, and
        outpatient infusion coordination. Brandis is a renowned industry speaker
        and KOL.
      </>
    ),
    bodyExt: (
      <>
        She has worked with multiple profound physicians and mid{dash}level
        providers including Melissa Costner, M.D., Jennifer Cather. M.D.,
        Melodie Young, N.P., Daniel Walker, M.D. and Dario Kivelevitch, M.D. She
        is the founder and CEO of BioMazze Coordination, President and Co{dash}
        Founder of Access Coordinator Boot Camp, and the Regional Biologic
        Coordinator for US Dermatology Partners in the DFW area.
      </>
    ),
  },
];

export default HeadshotData;
